import { render, staticRenderFns } from "./leftCent4.vue?vue&type=template&id=7cc4e6aa&scoped=true"
import script from "./leftCent4.vue?vue&type=script&lang=js"
export * from "./leftCent4.vue?vue&type=script&lang=js"
import style0 from "./leftCent4.vue?vue&type=style&index=0&id=7cc4e6aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc4e6aa",
  null
  
)

export default component.exports